// extracted by mini-css-extract-plugin
export default {"container":"FeatureChangeLog_container__AyMVV","item":"FeatureChangeLog_item__7TRTC","title":"FeatureChangeLog_title__S5tUJ","date":"FeatureChangeLog_date__whnVu"};